import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import RouteLoader from "modules/core/components/RouteLoader";
import Error404 from "modules/core/pages/Error404";

import { componentLazyImport } from "modules/core/utils/helpers";

import { getAuthToken } from "../../auth/utils/helpers";

import { authRoutesConstants } from "./routesConstants";
import { coreRoutesConstants } from "modules/core/routes/routesConstants";

// Pages
const Login = lazy(() => componentLazyImport(() => import("../pages/Login")));
const Signup = lazy(() => componentLazyImport(() => import("../pages/Signup")));
const ForgotPassword = lazy(() =>
  componentLazyImport(() => import("../pages/ForgotPassword"))
);
const ResetPassword = lazy(() =>
  componentLazyImport(() => import("../pages/ResetPassword"))
);

const AuthRoutes: React.FC = () => {
  const authToken = getAuthToken();

  const isAuthenticated = Boolean(authToken);

  if (isAuthenticated) {
    return <Redirect to={coreRoutesConstants.dashboard.href()} />;
  }

  return (
    <Suspense fallback={<RouteLoader />}>
      <Switch>
        <Route path={authRoutesConstants.login.path}>
          <Login />
        </Route>

        <Route path={authRoutesConstants.signup.path}>
          <Signup />
        </Route>

        <Route path={authRoutesConstants.forgotPassword.path}>
          <ForgotPassword />
        </Route>

        <Route path={authRoutesConstants.resetPassword.path}>
          <ResetPassword />
        </Route>

        <Route>
          <Error404 />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default AuthRoutes;
